<template>
  <div>
    <v-container>
      <v-btn @click="$emit('back')" flat>BACK</v-btn>
      <div style="margin-left: 30px">
        <div>
          <h5>Customers/Leads</h5>
          <div style="text-align: right">
            <span>
              <v-btn @click="exportAnandaCsv" outline color="primary">export</v-btn>
            </span>
            <search-date @onSearchDate="onSearch"></search-date>
          </div>
        </div>
        <v-data-table
          disable-initial-sort
          :loading="loading"
          :headers="headers"
          :items="fillteredDessert"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td style="padding-left: 15px">
              <div style="width: 155px">{{ props.item.name }}</div>
            </td>
            <td>
              <div>{{ props.item.email }}</div>
            </td>
            <td>
              <div>{{ props.item.phoneno }}</div>
            </td>
            <td>
              <div v-if="props.item.createtime">
                {{ props.item.createtime | dateFormat('DD/MM/YYYY') }}
              </div>
              <div v-else style="text-align: center">-</div>
            </td>
            <td>
              <div>{{ props.item.appointment | dateFormat('DD/MM/YYYY') }}</div>
            </td>
            <td>
              <div>{{ props.item.userid }}</div>
            </td>
            <td>
              <div>{{ props.item.salesforce }}</div>
            </td>
          </template>
        </v-data-table>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import SearchDate from './SearchDate.vue'

export default {
  props: ['data'],
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Phone', value: 'phoneno' },
        { text: 'Register Date', value: 'createtime' },
        { text: 'Appointment Date', value: 'appointment' },
        { text: 'Line UID', value: 'userid' },
        { text: 'Saleforce', value: 'salesforce' }
      ],
      menu1: false,
      desserts: [
        {
          name: '',
          email: '',
          phoneno: '',
          appointment: '',
          userid: '',
          salesforce: ''
        }
      ],
      loading: true,
      searchdate: {}
    }
  },
  components: {
    SearchDate
  },
  mounted() {
    this.getuseranandaregister(this.data)
  },
  computed: {
    fillteredDessert() {
      var result = this.desserts
      if (!this.searchdate) return this.desserts
      if (this.searchdate.appointmentStart) {
        result = result.filter((el) => {
          return moment(el.appointment).diff(this.searchdate.appointmentStart) >= 0
        })
      }
      if (this.searchdate.appointmentEnd) {
        result = result.filter(
          (el) => moment(el.appointment).diff(this.searchdate.appointmentEnd) <= 0
        )
      }
      if (this.searchdate.registerStart) {
        result = result.filter(
          (el) => moment(el.createtime).diff(this.searchdate.registerStart) >= 0
        )
      }
      if (this.searchdate.registerEnd) {
        result = result.filter((el) => moment(el.createtime).diff(this.searchdate.registerEnd) <= 0)
      }
      return result
    }
  },
  methods: {
    exportAnandaCsv: function () {
      let vm = this
      let csvContent = ''

      csvContent += 'Name,	Email,	Phone,	Register Date,	Appointment Date,	Line UID,	Saleforce\r\n'
      vm.fillteredDessert.map((val, index) => {
        csvContent += '"' + val.name + '",'
        csvContent += '"' + val.email + '",'
        csvContent += '"=""' + val.phoneno + '""",'
        csvContent += '"' + val.appointment + '",'
        csvContent += '"' + val.userid + '",'
        csvContent += '"' + val.salesforce + '",'
        csvContent += '\r\n'
      })

      vm.exportCsv(csvContent, 'result_user')
    },
    onSearch(date) {
      this.searchdate = date
    },

    getuseranandaregister(data) {
      var vm = this
      vm.loading = true
      api.getuseranandaregister(data, (error, response) => {
        if (error) console.error(error)
        vm.loading = false
        vm.desserts = response.data
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ananda/ShowResult.vue